import { render, staticRenderFns } from "./RedeemOTP.vue?vue&type=template&id=57b72519&scoped=true&"
import script from "./RedeemOTP.vue?vue&type=script&lang=js&"
export * from "./RedeemOTP.vue?vue&type=script&lang=js&"
import style0 from "./RedeemOTP.vue?vue&type=style&index=0&id=57b72519&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b72519",
  null
  
)

export default component.exports